import { render, staticRenderFns } from "./PromoteServices.vue?vue&type=template&id=3d552e81&scoped=true&"
import script from "./PromoteServices.vue?vue&type=script&lang=js&"
export * from "./PromoteServices.vue?vue&type=script&lang=js&"
import style0 from "./PromoteServices.vue?vue&type=style&index=0&id=3d552e81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d552e81",
  null
  
)

export default component.exports